<template>
  <div>
    <v-row>
      <v-col cols="12">
        <eve-of-current-bank-profile :data="data" />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <soft-rate :data="data" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import EveOfCurrentBankProfile from '@/theme/default/views/banking/risk/interest-rate/EVE/historical-eve-changes/EveOfCurrentBankProfile.vue'
import SoftRate from '@/theme/default/views/banking/risk/interest-rate/EVE/historical-eve-changes/SoftRate.vue'

export default {
  name      : 'HistoricalEVEChanges',
  components: { EveOfCurrentBankProfile, SoftRate },
  props     : {
    data: {
      type   : Object,
      default: () => null
    }
  }
}
</script>

<style scoped>
</style>
